import { render, staticRenderFns } from "./TSFW.vue?vue&type=template&id=56bf5773&scoped=true&"
import script from "./TSFW.vue?vue&type=script&lang=js&"
export * from "./TSFW.vue?vue&type=script&lang=js&"
import style0 from "./TSFW.vue?vue&type=style&index=0&id=56bf5773&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf5773",
  null
  
)

export default component.exports